export const  labelData = {
  //溢装
  tableLabel: [
    {
      label: '商品名称',
      param: 'productName',
      align: 'center',
      slot: 'productName',
    },

    {
      label: '商品编码',
      param: 'productSkuCode',
      align: 'center',
      slot: 'productSkuCode',
    },
    { label: '采购数量', param: 'quantity', align: 'center', width: '80' },
    {
      label: '溢装率',
      param: 'overShipmentRate',
      align: 'center',
      render: (row) => {
        return row.overShipmentRate
          ? Number(row.overShipmentRate) * 100 + '%'
          : '0%';
      },
    },
    {
      label: '未发数量',
      param: 'unSentQuantity',
      align: 'center',
      width: '80',
    },
    { label: '已发货', param: 'sentQuantity', align: 'center' },
    { label: '单位', param: 'goodsUnitName', align: 'center' },
    {
      label: '*本次发货数量',
      param: 'deliveryQuantity',
      align: 'center',
      slot: 'deliveryQuantity',
      width: '140',
    },
  ],
  //不溢装
  tableLabelNoOver: [
    {
      label: '商品名称',
      param: 'productName',
      align: 'center',
      slot: 'productName',
    },

    {
      label: '商品编码',
      param: 'productSkuCode',
      align: 'center',
      slot: 'productSkuCode',
    },
    { label: '采购数量', param: 'quantity', align: 'center', width: '80' },
    {
      label: '未发数量',
      param: 'unSentQuantity',
      align: 'center',
      width: '80',
    },
    {
      label: '已发货',
      param: 'sentQuantity',
      align: 'center',
      width: '80',
    },
    {
      label: '计量单位',
      param: 'goodsUnitName',
      align: 'center',
      width: '80',
    },
    {
      label: '*本次发货数量',
      param: 'deliveryQuantity',
      align: 'center',
      slot: 'deliveryQuantity',
      width: '140',
    },
  ],
// 溢装的询比价
  tableLabelInquiry:[
    {
      label: '商品名称',
      param: 'productName',
      align: 'center',
      slot: 'productName',
    },

    {
      label: '商品编码',
      param: 'productSkuCode',
      align: 'center',
      slot: 'productSkuCode',
    },
    { label: '采购数量', param: 'quantity', align: 'center', width: '80' },
    {
      label: '溢装率',
      param: 'overShipmentRate',
      align: 'center',
      render: (row) => {
        return row.overShipmentRate
          ? Number(row.overShipmentRate) * 100 + '%'
          : '0%';
      },
    },
    {
      label: '未发数量',
      param: 'unSentQuantity',
      align: 'center',
      width: '80',
    },
    { label: '已发货', param: 'sentQuantity', align: 'center' },
    { label: '单位', param: 'goodsUnitName', align: 'center' },
    {
      label: '*本次发货数量',
      param: 'deliveryQuantity',
      align: 'center',
      slot: 'deliveryQuantity',
      width: '140',
    },
    { label: '*总重量(KG)', param: 'unitweight', align: 'center',slot:'unitweight', width: '120', },
    { label: '*总体积(m³)', param: 'unitvolume', align: 'center',slot:'unitvolume', width: '120', },
  ],
// 不溢装的询比价
  tableLabelNoOverInquiry:[
    {
      label: '商品名称',
      param: 'productName',
      align: 'center',
      slot: 'productName',
    },

    {
      label: '商品编码',
      param: 'productSkuCode',
      align: 'center',
      slot: 'productSkuCode',
    },
    { label: '采购数量', param: 'quantity', align: 'center', width: '80' },
    {
      label: '未发数量',
      param: 'unSentQuantity',
      align: 'center',
      width: '80',
    },
    {
      label: '已发货',
      param: 'sentQuantity',
      align: 'center',
      width: '80',
    },
    {
      label: '计量单位',
      param: 'goodsUnitName',
      align: 'center',
      width: '80',
    },
    {
      label: '*本次发货数量',
      param: 'deliveryQuantity',
      align: 'center',
      slot: 'deliveryQuantity',
      width: '140',
    },
    { label: '*总重量(KG)', param: 'unitweight', align: 'center',slot:'unitweight', width: '120', },
    { label: '*总体积(m³)', param: 'unitvolume', align: 'center',slot:'unitvolume', width: '120', },
  ],
}